import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../Assets/Shokhlogo.png";
import cvFile from "../Assets/Shohruh Karimqulov CV .pdf";
import { Drawer } from "antd";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onClose = () => {
    setIsMenuOpen(false);
  };
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false); // Close the menu after scrolling
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/">
          <img src={logo} alt="Logo" className="header-logo" />
        </Link>

        {/* Hamburger Icon (for mobile view) */}
        <div className="menu-icon" onClick={toggleMenu}>
          ☰
        </div>

        <Drawer
          placement="right"
          title="Menu"
          width={250}
          onClose={onClose}
          open={isMenuOpen}
          className="Drawer"
        >
          <li>
            <Link to="/projects" className="custom-link">
              Projects
            </Link>
          </li>
          <li
            className="custom-link-web"
            onClick={() => scrollToSection("about-me")}
          >
            About me
          </li>
          <li>
            <Link to="/articles" className="custom-link">
              Articles
            </Link>
          </li>
          <li>
            <a href={cvFile} download="Shohruh Karimqulov CV.pdf" className="custom-link">
              CV
            </a>
          </li>
          <li
            className="custom-link-web"
            onClick={() => scrollToSection("contact-me")}
          >
            Contact
          </li>
        </Drawer>

        {/* Menu */}
        <nav className={`menu ${isMenuOpen ? "menu-open" : ""}`}>
          <ul>
            <li>
              <Link to="/projects">Projects</Link>
            </li>
            <li
              className="custom-link-web"
              onClick={() => scrollToSection("about-me")}
            >
              About me
            </li>
            <li>
              <Link to="/articles">Articles</Link>
            </li>
            <li>
              <a href={cvFile} download="Shohruh Karimqulov CV.pdf">
                CV
              </a>
            </li>
            <li
              className="custom-link-web"
              onClick={() => scrollToSection("contact-me")}
            >
              Contact
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;